module.exports = __webpack_public_path__ + "static/media/alert-triangle-grey.ba5fccd2.svg";